import React from 'react'
import styled from 'styled-components'
import LinkSpiedini from './LinkSpiedini'
// import LinkFoodServices from './LinkFoodServices'
import TranslateToggle from './TranslateToggle'
import vars from '../lib/styled'

const Tray = styled.aside`
  display: flex;
  justify-content: flex-end;
  background-color: ${vars.muted};
  padding: 0.45rem 0;
`

const NavBarTray = (rest) => (
  <Tray>
    <LinkSpiedini {...rest} />
  {/*  <LinkFoodServices {...rest} /> */}
    <TranslateToggle {...rest} />
  </Tray>
)

NavBarTray.propTypes = {}
NavBarTray.defaultProps = {}

export default NavBarTray
